<div class="card-buttons-container">
  <button
    *ngIf="isExportEnable"
    mat-button
    mat-raised-button
    (click)="exportHandler()">
    Esporta
  </button>
  <button
    *ngIf="entityId && className"
    mat-button
    mat-raised-button
    (click)="uiCollectionService.showCollectionPickerHandler([entityId], className)">
    Aggiungi collezione
  </button>
</div>

<mat-form-field class="card-status">
  <mat-select
    [placeholder]="'Stato' | translate"
    [value]="entity?.status"
    (selectionChange)="changeStatusHandler($event)">
    <mat-option
      [value]="s.value"
      *ngFor="let s of statuses">
      {{ s.label }}
    </mat-option>
  </mat-select>
</mat-form-field>

<div class="card-meta-info">
  <span>
    Creato: {{ entity?.createdAt | date : 'dd/MM/yyyy HH:mm' }}
  </span>
  <span>
    Aggiornato: {{ entity?.updatedAt | date : 'dd/MM/yyyy HH:mm' }}
  </span>
  <span>Utente: {{ username$ | async }}</span>
</div>

<div class="card-links">
  <span>
    <a
      href
      (click)="$event.preventDefault(); showAudits()">
      Visualizza Log Operazioni
    </a>
  </span>
</div>

<!--<div class="collections-links">-->
<!--  <mat-divider></mat-divider>-->
<!--  <mat-nav-list>-->
<!--    <h4>Links a Collezioni</h4>-->
<!--    @for (collection of collections; track collection) {-->
<!--      <a-->
<!--        mat-list-item-->
<!--        _target="_blank"-->
<!--        [routerLink]="['/collections/manager',collection.id]">-->
<!--        {{ collection.titolo }}</a>-->
<!--    }-->
<!--  </mat-nav-list>-->
<!--  @if (collectionsLoading) {-->
<!--    <mat-spinner></mat-spinner>-->
<!--  }-->
<!--</div>-->
